import React, { useEffect, useState, useRef } from 'react';
import './MainInicio.css';
import { useNavigate } from "react-router-dom";
import Header from '../Header/Header.js';

import * as THREE from "three";
import GLOBE from "vanta/dist/vanta.globe.min";

function MainInicio() {
  const navigate = useNavigate();

  const [overlayVisible, setOverlayVisible] = useState(true);
  const [symbolOpened, setSymbolOpened] = useState(false);
  const [showName, setShowName] = useState(false);
  const [moveToSide, setMoveToSide] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [fadeOutIntro, setFadeOutIntro] = useState(false);

  const timers = useRef([]);
  const vantaRef = useRef(null);
  const vantaEffect = useRef(null);

  /* ====== VANTA ====== */
  useEffect(() => {
    // Pequeño retardo para asegurar que el DOM está listo
    const timer = setTimeout(() => {
      if (vantaRef.current && !vantaEffect.current) {
        vantaEffect.current = GLOBE({
          el: vantaRef.current,
          THREE,
          mouseControls: true,
          touchControls: false,
          gyroControls: false,
          color: 0x0ac694,          // Color principal del globo (verde)
          backgroundColor: 0xFFFFFF, // Fondo blanco
          size: 0.8,
          speed: 0.6,
        });
        console.log('Vanta effect created');
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      if (vantaEffect.current) {
        vantaEffect.current.destroy();
        vantaEffect.current = null;
      }
    };
  }, []);

  /* ====== INTRO ====== */
  useEffect(() => {
    timers.current.push(setTimeout(() => setSymbolOpened(true), 300));
    timers.current.push(setTimeout(() => setShowName(true), 1400));
    timers.current.push(setTimeout(() => setMoveToSide(true), 2600));

    return () => {
      timers.current.forEach(t => clearTimeout(t));
    };
  }, []);

  useEffect(() => {
    if (!moveToSide) return;

    timers.current.push(setTimeout(() => {
      setFadeOutIntro(true);
      timers.current.push(setTimeout(() => {
        setOverlayVisible(false);
        setShowAll(true);
      }, 400));
    }, 120));

  }, [moveToSide]);

  return (
    <>
      <Header />

      {/* Fondo Vanta */}
      <div ref={vantaRef} className="vanta-background" />

      {/* Overlay blur (solo durante la intro, pero ahora sin fondo para no tapar) */}
      {overlayVisible && (
        <div className={`vanta-blur-overlay ${fadeOutIntro ? 'fade-out' : ''}`} />
      )}

      {/* INTRO */}
      {overlayVisible && (
        <div className={`intro-overlay ${symbolOpened ? 'opened' : ''} ${showName ? 'show-name' : ''}`}>
          <div className="intro-symbol-container">
            <div className="symbol intro-symbol">
              <span className="left">&lt;</span>
              <span className="right">/&gt;</span>
            </div>
            <div className={`brand-name ${showName ? 'visible' : ''}`}>
              <h1>
                Tresatec<span className="Ricon">®</span>
              </h1>
            </div>
          </div>
        </div>
      )}

      {/* ===== CONTENIDO ===== */}
      <div className={`MainInicio-container ${showAll ? 'show-all' : ''}`}>
        <div className="hero-corporate">
          <span className="hero-eyebrow">Empresa de desarrollo tecnológico</span>
          <h1>
            Tecnología que impulsa
            <span> instituciones y organizaciones</span>
          </h1>
          <p>
            Diseñamos plataformas, sistemas y soluciones digitales a medida,
            acompañando a cada institución desde la idea hasta la implementación.
          </p>
          <div className="cta-container">
            <a
              href="https://wa.me/message/ORWIOZ4UP74NM1"
              target="_blank"
              rel="noopener noreferrer"
              className="service-btn-secondary"
            >
              Solicitar Asesoramiento
            </a>
            <button
              className="cta-secondary"
              onClick={() => navigate("/Plataformaeducativa")}
            >
              Conocer plataforma Tresaedu
            </button>
          </div>
          <p className="hero-trust">
            Desarrollo propio • Implementación completa • Soporte real
          </p>
        </div>
      </div>
    </>
  );
}

export default MainInicio;